/**
 * When Writings lays out for a desk rather than a phone: side panels as
 * columns or rails, the tools in the bar, no buttons or bars along the bottom
 * edge. (Below it: sheets, the bottom Thoughts and Taken buttons, the Join bar.)
 *
 * Width alone got this wrong (Niki, 10/2): a laptop window with a browser
 * sidebar open (Claude, Burrow's own extension) is 800–1100px wide, and a
 * plain 1024px cut turned it into the phone layout. So the rule is:
 *
 * - 1024px and wider: always a desk.
 * - 640–1023px: a desk when the main pointer is a mouse or trackpad
 *   (`pointer: fine`) — a narrowed desktop window. It condenses instead: the
 *   margins fold inline, quieter tools go into "···". A touch screen of that
 *   size (a tablet) keeps the phone layout.
 * - Under 640px: a phone, whatever the pointer.
 */
export const DESK = '(min-width: 1024px), (min-width: 640px) and (pointer: fine)'
